// extracted by mini-css-extract-plugin
export var alternate = "_1j-h";
export var black = "_1j-3";
export var blue = "_1j-d";
export var blueLight = "_1j-c";
export var brand = "_1j-7";
export var error = "_1j-9";
export var gray = "_1j-6";
export var grayBlue = "_1j-b";
export var iconWrapper = "_1j-4";
export var indigo = "_1j-e";
export var orange = "_1j-g";
export var pink = "_1j-f";
export var primary = "_1j-0";
export var purple = "_1j-8";
export var success = "_1j-5";
export var warning = "_1j-a";
export var white = "_1j-1";
export var whiteSuccess = "_1j-2";